<bci-wk-modal id="mymodal" class="modal">
  <div class="container-modal-eliminar">
    <img class="war" src="./assets/images/Seal.png" alt="waricon" />
    <div class="title wk-padding-top-24">
      <bci-wk-modal-title bciWkTypeH1000
        >¿Quieres anular tu visita agendada?</bci-wk-modal-title
      >
    </div>

    <p>
      La visita que quieres anular esta agendada para el día
      {{ this.data.reservas.dia | date : "d/M/yy" }}, a las
      {{ this.data.reservas.hora | timeFormat }} horas, en la sucursal
      {{ this.data.reservas.oficina }}, ubicada en
      {{ this.data.reservas.direccion | titlecase }}.
    </p>

    <bci-wk-modal-actions>
      <button bciWkButtonTertiary (click)="close()">En otro momento</button>
      <button bciWkButtonPrimary (click)="confirm()">
        Sí, la quiero anular
      </button>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
